import React from 'react';
import styled from 'styled-components';

type TProps = {
    fullscreen?: boolean;
    dotSize?: number;
    color?: string;
};

const siteHeaderHeight = '54px';

const Loader = ({ color, dotSize, fullscreen }: TProps): JSX.Element => {
    const dotStyle = {
        ...(color && { backgroundColor: color }),
        ...(dotSize && { width: dotSize, height: dotSize }),
    };
    return (
        <BounceLoader className={`${fullscreen ? 'screenContainer' : ''}`} style={{ width: (dotSize || 1) * 3 + 12 }}>
            <div className="dot bounce1" style={dotStyle} />
            <div className="dot bounce2" style={dotStyle} />
            <div className="dot bounce3" style={dotStyle} />
        </BounceLoader>
    );
};

const BounceLoader = styled.div`
    width: 30px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    .dot {
        flex: 0 0 auto;
        width: 6px;
        height: 6px;
        background-color: ${({ theme }): string => `${theme.colors.body}`};
        border-radius: 100%;
        margin: 0 2px;
        animation-name: bounce;
        animation-duration: 1.4s;
        animation-fill-mode: ease-in-out;
        animation-iteration-count: infinite;
        animation-direction: both;
    }
    .bounce1 {
        animation-delay: -0.32s;
    }
    .bounce2 {
        animation-delay: -0.16s;
    }
    @keyframes bounce {
        0%,
        80%,
        100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        40% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }

    &.screenContainer {
        min-height: calc(100vh - ${siteHeaderHeight});
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export default Loader;
